<template>
  <SimpleDictView
    endpoint="users/stpn-types/"
    :title="$t('settings.titles.stpn')"
    :add-button="$t('settings.addButtons.stpn')"
    :fields="fields"
  />
</template>

<script>
import SimpleDictView from './SimpleDictView.vue'
export default {
  name: 'StpnTypesView',
  components: { SimpleDictView },
  computed: {
    fields() {
      return [{ key: 'name', label: this.$t('settings.fields.name') }]
    },
  },
}
</script>
